import { RootState } from '../types'

export const getBannerSelector = (state: RootState) => state.banner

export const getAllBannersSelector = (state: RootState) => state.banner.banners
